import '../styles/BoxText.css';

export function BoxText({ name, description, link_code, link_web, tools }) {

    const languages = [];

    if (tools) {

        languages.push(...tools);

    }

    return (

        <div className='boxText_c'>

            <h2>{name}</h2>

            <p>{description}</p>

            <ul className="tools_c">

                {languages && languages.map((item) =>

                    <li className='tools' key={item}>{item}</li>

                )}

            </ul>

            <div className="button_link-c">

                <a href={link_web} target="_blank" rel="noreferrer" className='button_link-web'>Visite o site</a>

                <a href={link_code} target="_blank" rel="noreferrer" className='button_link-web'>Ver o código</a>

            </div>

        </div>

    )

}

export function BoxTextHome({ title, text }) {

    return (

        <div className='boxText_c'>

            <h2>{title}</h2>

            <p>{text}</p>

        </div>

    )

}